import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import Fleetdashboard from "./Overview";
import Servicestatus from "./Servicestatus";
import Deliveryandpickups from "./Deliveryandpickups";
import Wheelalignmentdashboard from "./Wheelalignmentdashboard";
import Batteryandtyres from "./Batteryandtyres";
import Vehicleexpenses from "./Vehicleexpenses";
import Overtime from "./Overtime";
import CustomerReviews from "./CustomerReviews";
import Kpidashboard from "./Kpidashboard";
import Deliveriesandpickups from "./Deliveriesandpickups";
import Deliverypickupagentdashboard from "./Deliverypickupagentdashboard";
import Vendordashboard from "./Vendordashboard";
import Damagedowntimedashboard from "./Damagedowntimedashboard";
import Clutch from "./Clutch";

const Fleetdashboardmodule = () => {
  const navigate = useNavigate();
  const navItems = routeModules?.fleetdashboard?.sidebar || [];
  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    switch (activeItem) {
      case "Overview":
        return <Fleetdashboard />;
      case "KPI Dashboard":
        return <Kpidashboard />;
      case "Damage & Downtime":
        return <Damagedowntimedashboard />;
      case "Clutch":
        return <Clutch />;
      case "Service Status":
        return <Servicestatus />;
      case "Delivery and Pickup":
        return <Deliveryandpickups />;
      case "Wheel Alerts":
        return <Wheelalignmentdashboard />;
      case "Battery and Tyres":
        return <Batteryandtyres />;
      case "Vehicle Expenses":
        return <Vehicleexpenses />;
        case "Vendor Payments":
        return <Vendordashboard />;
      case "Overtime Details":
        return <Overtime />;
      case "Customer Reviews":
        return <CustomerReviews />;
      case "Delivery & Pickups Agent Dashboard":
        return <Deliverypickupagentdashboard />;
      case "Delivery and Pickup Details":
        return <Deliveriesandpickups />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   if (!loginTime || Date.now() - Number(loginTime) > 2 * 60 * 60 * 1000) {
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // }, [navigate]);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Layout
        module={"fleetdashboard"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          width: "50%",
        }}
      >
        <Toolbar />
        <Container
          maxWidth={false}
          sx={{ flexGrow: 1, minHeight: "100vh", overflow: "hidden" }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default Fleetdashboardmodule;
